import Selfie from "../../components/UI/Selfie/Selfie";

const SelfiePage = () => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
        padding: "24px",
      }}
    >
      <div
        style={{
          maxWidth: "584px",
          width: "100%",
          maxHeight: "calc(100vh - 100px)",
          backgroundColor: "#fff",
          borderRadius: "16px",
          boxShadow: "rgba(17, 12, 46, 0.15) 0px 48px 100px 0px",
          padding: "32px",
          overflow: "auto",
        }}
      >
        <Selfie />
      </div>
    </div>
  );
};

export default SelfiePage;
